import {HTMLAttributes} from "react";
import { APP_COLOR } from '../AtomsGlobalProps'

export enum HEADER_LEVEL {
    H1,
    H2,
    H3,
    H4
}
interface BaseHeaderProps extends HTMLAttributes<HTMLHeadingElement> {
    title: string; //todo zmienic na html i dodac children
    color?: APP_COLOR
    /** Kierunek centrowania paragrafu */
    align?: 'left' | 'center' | 'right' | 'justify'
}
export interface PageHeaderHProps extends BaseHeaderProps {
    level?: HEADER_LEVEL.H1 | HEADER_LEVEL.H2;
    line?: boolean;
}

export interface PageHeaderHWithoutLineProps extends BaseHeaderProps{
    level: HEADER_LEVEL.H3 | HEADER_LEVEL.H4;
    line?: never;
}

export type PageHeaderProps = PageHeaderHProps | PageHeaderHWithoutLineProps;
